import image1 from "../../Assets/CuttedEmeralds/WhatsApp Image 2025-05-06 at 3.13.27 PM.jpeg?format=webp";
import image2 from "../../Assets/CuttedEmeralds/WhatsApp Image 2025-05-06 at 3.13.26 PM.jpeg?format=webp";
import image3 from "../../Assets/CuttedEmeralds/WhatsApp Image 2025-05-06 at 3.13.26 PM (1).jpeg?format=webp";
import image4 from "../../Assets/Photos-new/image_2025-05-25_12-05-30.png?format=webp";
import image5 from "../../Assets/Photos-new/image_2025-05-25_12-06-26.png?format=webp";
import image6 from "../../Assets/Photos-new/image_2025-05-25_12-07-02.png?format=webp"

/*new images */

import imgc2 from "../../Assets/the-cut-emerold-img/imgc2of10.jpg?format=webp";
import imgc3 from "../../Assets/the-cut-emerold-img/imgc3of10.jpg?format=webp";
import imgc4 from "../../Assets/the-cut-emerold-img/imgc4of10.jpg?format=webp";
import imgc5 from "../../Assets/the-cut-emerold-img/imgc5of10.jpg?format=webp";
import imgc6 from "../../Assets/the-cut-emerold-img/imgc6of10.jpg?format=webp"



// Dummy data for cut emeralds
export const cutEmeralds = [
    {
      id: "c1",
      image: imgc2,
      carats: 3.25,
      cut: "Oval",
      clarity: "VS",
      color: "Vivid Green",
      origin: "Colombia",
      certification: "GIA",
      price: "$32,500",
    },
    {
      id: "c2",
      image: imgc3,
      carats: 3.25,
      cut: "Oval",
      clarity: "VS",
      color: "Vivid Green",
      origin: "Colombia",
      certification: "GIA",
      price: "$32,500",
    },
    {
      id: "c3",
      image: imgc4,
      carats: 3.25,
      cut: "Oval",
      clarity: "VS",
      color: "Vivid Green",
      origin: "Colombia",
      certification: "GIA",
      price: "$32,500",
    },
    {
      id: "c4",
      image: imgc5,
      carats: 3.25,
      cut: "Oval",
      clarity: "VS",
      color: "Vivid Green",
      origin: "Colombia",
      certification: "GIA",
      price: "$32,500",
    },
    {
      id: "c5",
      image: imgc6,
      carats: 3.25,
      cut: "Oval",
      clarity: "VS",
      color: "Vivid Green",
      origin: "Colombia",
      certification: "GIA",
      price: "$32,500",
    },
    {
      id: "c6",
      image: image1,
      carats: 3.25,
      cut: "Oval",
      clarity: "VS",
      color: "Vivid Green",
      origin: "Colombia",
      certification: "GIA",
      price: "$32,500",
    },
    {
      id: "c7",
      image: image2,
      carats: 3.25,
      cut: "Oval",
      clarity: "VS",
      color: "Vivid Green",
      origin: "Colombia",
      certification: "GIA",
      price: "$32,500",
    },
    {
      id: "c8",
      image: image3,
      carats: 3.25,
      cut: "Oval",
      clarity: "VS",
      color: "Vivid Green",
      origin: "Colombia",
      certification: "GIA",
      price: "$32,500",
    },
    // {
    //   id: "c1",
    //   image: image4,
    //   carats: 3.25,
    //   cut: "Oval",
    //   clarity: "VS",
    //   color: "Vivid Green",
    //   origin: "Colombia",
    //   certification: "GIA",
    //   price: "$32,500",
    // },
    {
      id: "c9",
      image: "https://i.pinimg.com/736x/9e/d6/68/9ed6681875037c88ed516260f48bb55d.jpg",
      carats: 2.78,
      cut: "Emerald",
      clarity: "VVS",
      color: "Deep Green",
      origin: "Zambia",
      certification: "GRS",
      price: "$27,800",
    },
    {
      id: "c10",
      image: "https://i.pinimg.com/736x/ce/69/cb/ce69cb17b6ec5cbc6556975eeddc17ce.jpg",
      carats: 4.12,
      cut: "Cushion",
      clarity: "SI",
      color: "Medium Green",
      origin: "Brazil",
      certification: "AGL",
      price: "$41,200",
    },
    {
      id: "c11",
      image: "https://i.pinimg.com/736x/95/bf/39/95bf3939810f7b2c531e0df758a7aa09.jpg",
      carats: 1.95,
      cut: "Pear",
      clarity: "VS",
      color: "Bluish Green",
      origin: "Ethiopia",
      certification: "GIA",
      price: "$19,500",
    },
    {
      id: "c12",
      image: "https://i.pinimg.com/736x/ca/9f/f1/ca9ff17668003371a6cd961be8403dcd.jpg",
      carats: 2.45,
      cut: "Round",
      clarity: "VVS",
      color: "Intense Green",
      origin: "Colombia",
      certification: "GRS",
      price: "$24,500",
    },
    {
      id: "c13",
      image: "https://i.pinimg.com/736x/4d/c3/62/4dc3620978f1d82ee47a8f59e46ac1d4.jpg",
      carats: 3.67,
      cut: "Asscher",
      clarity: "VS",
      color: "Vivid Green",
      origin: "Zambia",
      certification: "GIA",
      price: "$36,700",
    },
    {
      id: "c14",
      image: image4,
      carats: 3.25,
      cut: "Oval",
      clarity: "VS",
      color: "Vivid Green",
      origin: "Colombia",
      certification: "GIA",
      price: "$32,500",
    },
    {
      id: "c15",
      image: image5,
      carats: 3.25,
      cut: "Oval",
      clarity: "VS",
      color: "Vivid Green",
      origin: "Colombia",
      certification: "GIA",
      price: "$32,500",
    },
    {
      id: "c16",
      image: image6,
      carats: 3.25,
      cut: "Oval",
      clarity: "VS",
      color: "Vivid Green",
      origin: "Colombia",
      certification: "GIA",
      price: "$32,500",
    },
  ]
  